import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface BillingTypeStats {
  totalStudentActivities: number;
  withOverrides: number;
  perSessionOverrides: number;
  monthlyOverrides: number;
  defaultBehavior: number;
}

export const useBillingTypeStats = () => {
  const [stats, setStats] = useState<BillingTypeStats>({
    totalStudentActivities: 0,
    withOverrides: 0,
    perSessionOverrides: 0,
    monthlyOverrides: 0,
    defaultBehavior: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadStats = async () => {
    try {
      setLoading(true);
      setError(null);

      // Usar la nueva función segura de base de datos
      const { data, error } = await supabase
        .rpc('get_student_activities_billing_stats');

      if (error) throw error;

      const result = data?.[0] || {
        total_student_activities: 0,
        with_overrides: 0,
        per_session_overrides: 0,
        monthly_overrides: 0,
        default_behavior: 0
      };

      setStats({
        totalStudentActivities: Number(result.total_student_activities),
        withOverrides: Number(result.with_overrides),
        perSessionOverrides: Number(result.per_session_overrides),
        monthlyOverrides: Number(result.monthly_overrides),
        defaultBehavior: Number(result.default_behavior)
      });

    } catch (err: any) {
      
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  return { stats, loading, error, refetch: loadStats };
};